import { render, staticRenderFns } from "./Error403.vue?vue&type=template&id=4db83dfc&scoped=true"
import script from "./Error403.vue?vue&type=script&lang=js"
export * from "./Error403.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db83dfc",
  null
  
)

export default component.exports